export const SortAlphabetically = (a,b, key, type = 'asc') => {
    let nameA=a[key].toLowerCase(), nameB=b[key].toLowerCase()
    if (nameA < nameB)
        return type === 'asc' ? -1 : 1
    if (nameA > nameB)
        return type === 'asc' ? 1 : -1
    return 0
}
